import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';

import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { BehaviorSubject } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LocalizationService } from '@services/localization.service';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { ChangeDetectorRef } from '@angular/core';
import 'hammerjs';
import { UserHelper } from '@helpers/user.helper';

@Component({
  selector: 'live-upcoming',
  templateUrl: '../sharedTemplates/live-upcoming.component.html',
})
export class LiveUpcoming implements AfterViewInit {
  preMatchList = [];
  preMatchobservable = new BehaviorSubject<any>([]);
  favPreMatchobservable = new BehaviorSubject<any>([]);
  _selectedOdds: OddModel[] = [];
  _catId = '0';
  oddMarketingValue = [0];

  contentHeight;
  othersHeight;

  @HostListener('window:resize', ['$event'])
  onResize() {
    // used windopw-innerWidth
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  constructor(
    private _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _SignalRService: SignalrServiceLegacy,
    private _LocalizationService: LocalizationService,
    private _webWorkerService: WebWorkerService,
    private cdRef: ChangeDetectorRef,
    private _UserHelper: UserHelper
  ) {}

  ngAfterViewInit() {
    this.getUpcoming();

    //Daha önce seçilen oddları tekrar seçsin
    this._ApiService.selectedOddsEvent.subscribe(x => {
      this._selectedOdds = x as OddModel[];
    });
    this._ApiService.getSelectedOdds();
  }
  oddMarketingChange(e) {
    this.oddMarketingValue[0] = e;

    // Favorable states Updates
    const x = this.getFavorableStates(this.preMatchList);
    this.preMatchList = x;
    this.preMatchobservable.next(this.preMatchList);
    //////console.log('E', e);
    //this.cdRef.detectChanges();
  }
  //getGetPopularFixture(_sId) {

  //  if (this._UiHelper.leftMenu == true) {
  //    this._UiHelper.setLeftMenu();
  //  }

  //  this._UiHelper.setLoadingDialog(true);
  //  this._ApiService.getFixture('0', '-1').then((x) => {
  //    this.preMatchList = x;
  //    this.preMatchobservable.next(this.preMatchList);

  //    this._UiHelper.setLoadingDialog(false);
  //  });

  //}

  heightsetter(c) {
    this.contentHeight = c - this.othersHeight;
    this.contentHeight += 'px';
    ////console.log(this.contentHeight);
  }

  getFavorableStates(_x) {
    const a = this._UserHelper.favoriedMatches;
    return _x.map(y => {
      // ////console.log(a, y.BetradarMatchId);
      if (a == null) {
        return y;
      }
      if (a.includes(y.BetradarMatchId)) {
        y['favorableState'] = true;
        return y;
      } else {
        y['favorableState'] = false;
        return y;
      }
    });
  }

  getGetFixture() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .getFixture()
      .then(x => {
        x = this.getFavorableStates(x);
        this.preMatchList = x;
        // ////console.log('prematch', x);
        this.preMatchobservable.next(this.preMatchList);
        //this.changesearch(false);
        this._UiHelper.setLoadingDialog(false);
        this.cdRef.detectChanges();
      })
      .catch(err => console.log('live-upcoming', err));
  }
  getFavs() {
    this._ApiService.getSearch4Favs().then(x => {
      x = this.getFavorableStates(x);
      this.favPreMatchobservable.next(x);
      this.cdRef.detectChanges();
    });
  }
  getUpcoming() {
    this._ApiService.getUpcomingFixture().then(x => {
      x = this.sortBy(x, false, 'MatchDate');
      this.preMatchList = x;
      this.preMatchobservable.next(this.preMatchList);
      //////console.warn("upcoming",x);
      this._UiHelper.setLoadingDialog(false);
    });
  }
  sortBy(items: any[], reverse: boolean, sortedBy: string) {
    let shortedData;

    if (!reverse) {
      shortedData = items.sort((a, b) => {
        const nameA = a[sortedBy];
        const nameB = b[sortedBy];
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      });
    } else {
      shortedData = items.sort((a, b) => {
        const nameA = a[sortedBy];
        const nameB = b[sortedBy];
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
      });
    }

    return shortedData;
  }
}
export class OddModel {
  constructor(OddId: number) {
    this.OddId = OddId;
  }

  OddId: number;
}
